import Column from '@components/Column';
import Header from '@components/Header';
import { AppScreen } from '@stackflow/plugin-basic-ui';
import { ActivityComponentType } from '@stackflow/react';
import { useTranslation } from 'react-i18next';

import SignInFooter from './components/SignInFooter';
import SignInForm from './components/SignInForm';
import SignInContextProvider from './context/SignInContextProvider';

const SignInWithPhoneActivity: ActivityComponentType = () => {
    const { t } = useTranslation('signIn');
    return (
        <SignInContextProvider>
            <AppScreen>
                <Column fullWidth fullHeight>
                    <Header title={t('phone.header')} />
                    <SignInForm/>
                    <SignInFooter/>
                </Column>
            </AppScreen>
        </SignInContextProvider>
    );
};

export default SignInWithPhoneActivity;
